import { RangeFilterItemWithValues } from '@aboutyou/backbone/endpoints/filters/filters'
import React, { FC } from 'react'
import PriceFilter from './RangeFilters/PriceFilter'

const RangeFilter: FC<{
  filter: RangeFilterItemWithValues
}> = ({ filter }) => {
  switch (filter.slug) {
    case 'prices':
      return <PriceFilter />

    default:
      return null
  }
}

export default RangeFilter
